<script setup lang="ts">
import { computed, ref } from 'vue';
import { useFetch } from 'nuxt/app';
import { useI18n } from 'vue-i18n';
import type { PortableTextComponentProps } from '@portabletext/vue';
import SurpriseBagCardUi from '@pkg/ui/components/ui/surpriseBagCard/SurpriseBagCardUi.vue';
import { isRenderableBag, resolveSurpriseBagCardRequest, type SurpriseBagCardValue } from './surpriseBagCard/sources';

const props = defineProps<PortableTextComponentProps<SurpriseBagCardValue>>();

const { locale } = useI18n();

const request = resolveSurpriseBagCardRequest(props.value, locale.value);

const { data } = request
  ? await useFetch(request.url, { query: request.query, key: request.key })
  : { data: ref(null) };

const bag = computed(() => {
  const resolved = request && data.value ? request.extract(data.value) : null;
  return isRenderableBag(resolved) ? resolved : null;
});
</script>

<template>
  <div v-if="bag" class="c-portable-editor__embed c-portable-editor__surprise-bag-card">
    <ClientOnly>
      <SurpriseBagCardUi :article="bag" />
    </ClientOnly>
  </div>
</template>

<style scoped>
.c-portable-editor__surprise-bag-card {
  display: flex;
  justify-content: center;
  margin: 24px 0;
}
</style>
